<admin-page-simple-content
    [pageError]="pageError"
    [pageStatus]="pageStatus"
    [title]="'Mediaclip Management'"
    [icon]="'business_center'"
>
    @if (storeWithCleanupConfig) {
        @let subscription = storeWithCleanupConfig.subscription;
        <div class="content">
            @if (subscription.cleanup.projectExpirations || subscription.cleanup.pendingProjectExpirations) {

                <form #form="ngForm" (ngSubmit)="save()">
                    <h2 class="project-expirations-title">Project expiration notification settings</h2>
                    <p class="project-expirations-note">Values defined here will override the notification delays defined at the <a
                        [routerLink]="['/subscriptions', subscription.id, 'cleanup']">subscription</a> level.</p>
                    <mat-form-field floatLabel="always">
                        <mat-label>Photobook</mat-label>
                        <input
                            matInput
                            [(ngModel)]="cleanupConfig.photobookNotificationDelayInDays"
                            name="photobookNotificationDelayInDays"
                            [placeholder]="'Using subscription value: ' + (subscription.cleanup.projectExpirations?.photobookNotificationDelayInDays ?? subscription.cleanup.pendingProjectExpirations?.photobookNotificationDelayInDays ?? 1).toString()"
                            min="1"
                            type="number"
                            autocomplete="off"
                        />
                    </mat-form-field>
                    <mat-form-field floatLabel="always">
                        <mat-label>Gifting</mat-label>
                        <input
                            matInput
                            [(ngModel)]="cleanupConfig.giftingNotificationDelayInDays"
                            name="giftingNotificationDelayInDays"
                            [placeholder]="'Using subscription value: ' + (subscription.cleanup.projectExpirations?.giftingNotificationDelayInDays ?? subscription.cleanup.pendingProjectExpirations?.giftingNotificationDelayInDays ?? 1).toString()"
                            min="1"

                            type="number"
                            autocomplete="off"
                        />
                    </mat-form-field>
                    <mat-form-field floatLabel="always">
                        <mat-label>Print</mat-label>
                        <input
                            matInput
                            [(ngModel)]="cleanupConfig.printNotificationDelayInDays"
                            name="printNotificationDelayInDays"
                            [placeholder]="'Using subscription value: ' + (subscription.cleanup.projectExpirations?.printNotificationDelayInDays ?? subscription.cleanup.pendingProjectExpirations?.printNotificationDelayInDays ?? 1).toString()"
                            min="1"
                            type="number"
                            autocomplete="off"
                        />
                    </mat-form-field>
                    <admin-save-button [disabled]="!form.valid" [pageStatus]="pageStatus"></admin-save-button>
                </form>
            } @else {
                <p>Cleanup is not enable for this <a [routerLink]="['/subscriptions', subscription.id, 'cleanup']">subscription</a></p>
            }

            @if (pageStatus === "saveError" && pageError) {
                <admin-error [error]="pageError"></admin-error>
            }
        </div>
    }
</admin-page-simple-content>

